
import Pagination from '@/components/Pagination.vue'
import { defineComponent, getCurrentInstance, toRefs, reactive, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
export default defineComponent({
    name: 'User',
    components: {Pagination},
    setup () {
        const { proxy } = getCurrentInstance() as any
        const router = useRouter()
        const store = useStore()

        const state = reactive({
            filters: {
                parent_name:        '',     // 总账号
                brand_name:         '',     // 品牌
                shop_name:          '',     // 门店名
                username:           '',     // 门店用户名
                limit:              10,     // 每页条数
                page:               1,      // 当前页码
            },
            tableData:              [],     // 账号列表
            total:                  0,      // 列表总条数
            dialogVisible:          false,  // 弹框是否显示

            // 获取门店账号列表
            getUserList: () => {
                proxy.$http.get(`/admin/user/getAdminUserList?${joinParams(state.filters)}`).then((res:any) => {
                    const {code, data, count, msg} = res
                    if (code != 200) {
                        return proxy.$message({ type: 'error', message: msg })
                    }
                    state.tableData = data;
                    state.total = count;
                })
            },
            // 表格 index 连续
            tableIndex: (index) => {
                const { page, limit } = state.filters
                return (page - 1) * limit + index + 1
            },
            handleEdit: (id:string) => {
                router.push(`/permission/user/edit?id=${id}&is_shop=1`)
            },
            changeStatus: (row:any) => {
                const {id, status} = row
                proxy.$http.get(`/admin/User/forbidden?id=${id}&status=${1^status}`).then(res => {
                    if(res.code == 0){
                        proxy.$message({type: 'success', message: res.msg})
                        state.getUserList()
                    }else{
                        proxy.$message({type: 'error', message: res.msg})
                    }
                })
            },
            // 分页
            onPageChange: (val:number) => {
                state.filters.page = val
                state.getUserList()
            },
            onSizeChange: (val:number) => {
                state.filters.limit = val
                state.getUserList()
            },
            // 搜索
            onSearch: () => {
                state.filters.page = 1;
                state.getUserList();
            },
            // 批量上传成功
            onUploadSuccess: async (res) => {
                const {code, data, msg} = res
                if (code != 200) {
                    return proxy.$message({ type: 'error', message: msg })
                }

                data.dialogVisible = false
                router.push(`/permission/user/shop-user-confirm?code=${data.code}`)
            },
            // 关闭弹框前清空已上传文件列表
            dialogBeforeClose: () => {
                proxy.$refs.upload.clearFiles()
                state.dialogVisible = false
            }
        })
        state.getUserList()
        onActivated(() => {
            state.getUserList()
        })
        return { ...toRefs(state), store, Keys }
    }
})
